import { get } from 'lodash';

import { GET_OFFICERS } from './';

import organizationEndpoints from '../api/organization/organizationEndpoints';
import getOfficersSuccess from './get-officers-success';
import getOfficersError from './get-officers-error';

import { JMS_INMATE_VALUE } from '../modules/FormBuilder/constants/fieldAutocomplete';
import { unEscapeInput } from '../utils/request';

export default (payload = {}, next = () => {}) => {
  return (dispatch, getState) => {
    const {
      session: { currentUser: { agencyId: userAgencyId = '' } = {} },
    } = getState();
    dispatch({ type: GET_OFFICERS, payload });

    const { options = {}, agencyId: _agencyId, value } = payload;
    const { orCriteria, source } = options;
    const agencyId = _agencyId || userAgencyId;
    const getExternalUsers =
      source === JMS_INMATE_VALUE
        ? 'getInmatesSearch'
        : 'getExternalStaffMembersSearch';

    organizationEndpoints[getExternalUsers](agencyId, value, orCriteria)
      .then(response => {
        // OACC-97: JMS org-service search responses arrive percent-encoded
        // (e.g. emailAddress "a%40b.test"), unlike officer/civilian data which is
        // plaintext, so the selection-write never decoded external users. Decode
        // once here — mirroring the report-fetch path (api/reports.js unEscapeInput,
        // which recurses into nested typeSpecificAttributes) — so values render
        // decoded AND the escape-on-save/unescape-on-fetch round-trip stays
        // balanced (prevents the %2540 double-encoding).
        const users = response.map(user =>
          unEscapeInput({
            ...user,
            ...get(user, 'person', {}),
            id: get(user, 'id') + [],
          })
        );
        dispatch(getOfficersSuccess(users, payload));
        next(null, users);
      })
      .catch(error => {
        dispatch(getOfficersError(get(error, ['response', 'status'])));
        next(error);
      });
  };
};
